import { action, observable, makeObservable } from 'mobx';
import { Model, IModelAttributes, attribute, entity } from 'Models/Model';

export interface ISmsTemplateEntityAttributes extends IModelAttributes {
	key: string;
	displayName: string;
	content: string;
}
@entity('SmsTemplateEntity', 'Sms Template')
export default class SmsTemplateEntity extends Model implements ISmsTemplateEntityAttributes {
	/**
	 * Fields to exclude from the JSON serialization in create operations.
	 */
	public static excludeFromCreate: string[] = [];

	/**
	 * Fields to exclude from the JSON serialization in update operations.
	 */
	public static excludeFromUpdate: string[] = [];

	/**
	 * The key used to get the sms template.
	 */
	@observable
	@attribute<SmsTemplateEntity, string>()
	public key: string;

	/**
	 * The name of the template that will be showed around the application.
	 */
	@observable
	@attribute<SmsTemplateEntity, string>()
	public displayName: string;

	/**
	 * The content that will be used for this SMS template.
	 */
	@observable
	@attribute<SmsTemplateEntity, string>()
	public content: string;

	constructor(attributes?: Partial<ISmsTemplateEntityAttributes>) {
		super(attributes);

		makeObservable(this);

		this.assignAttributes(attributes);
	}

	/**
	 * Assigns fields from a passed in JSON object to the fields in this model.
	 * Any reference objects that are passed in are converted to models if they are not already.
	 * This function is called from the constructor to assign the initial fields.
	 */
	public assignAttributes(attributes?: Partial<ISmsTemplateEntityAttributes>) {
		super.assignAttributes(attributes);

		if (attributes) {
			if (attributes.key !== undefined) {
				this.key = attributes.key;
			}
			if (attributes.displayName !== undefined) {
				this.displayName = attributes.displayName;
			}
			if (attributes.content !== undefined) {
				this.content = attributes.content;
			}
		}
	}
}
